import Link from "next/link";

export const fragenUnfallAuto = [
  {
    question: "Darf man ein Unfallauto verkaufen?",
    answer: (
      <>
        <p>
          Ja, in Österreich ist es erlaubt, ein Unfallauto zu verkaufen.
          Allerdings gibt es dabei einige wichtige rechtliche Vorgaben zu
          beachten. Du bist als Verkäufer verpflichtet, den Unfallschaden
          ehrlich anzugeben und im Kaufvertrag zu dokumentieren. Verschweigst du
          den Schaden absichtlich, kann dies als Täuschung oder sogar Betrug (§
          146 StGB) gewertet werden, was rechtliche Konsequenzen nach sich
          ziehen kann.
        </p>

        <p>
          Auch Fahrzeuge mit Totalschaden oder schweren Schäden können verkauft
          werden – entweder an private Käufer, Händler oder spezialisierte
          Plattformen wie Autoeinfachlos. Hier bekommst du eine marktgerechte
          Bewertung deines Unfallautos und musst dich nicht um komplizierte
          Formalitäten kümmern.
        </p>
        <p>
          Mit Autoeinfachlos ist der Verkauf deines Unfallautos sicher,
          transparent und stressfrei. So kannst du rechtliche Probleme vermeiden
          und den besten Preis erzielen.
        </p>
      </>
    ),
  },
  {
    question: "Was muss ich beachten, wenn ich ein Unfallauto verkaufe?",
    answer: (
      <>
        <p>
          Beim Verkauf eines Unfallautos gibt es einige wichtige Punkte, die du
          beachten solltest, um rechtliche Probleme zu vermeiden und den
          bestmöglichen Preis zu erzielen:
        </p>

        <ol className="AV-Fragen-ol">
          <li>
            <strong>Unfallschaden immer angeben: </strong>
            Fahrzeuge, die nach einem Unfall beschädigt wurden.
          </li>
          <li>
            <strong>Wertermittlung durchführen: </strong>
            Lass den Wert deines Unfallautos professionell ermitteln, um einen
            fairen Marktpreis zu erhalten. Dafür kannst du auch unser Fahrzeug
            Bewertungstool nutzen.
          </li>
          <li>
            <strong>Nicht fahrbereite Fahrzeuge verkaufen: </strong>
            Auch nicht fahrbereite Unfallautos kannst du problemlos verkaufen.
            Mit Autoeinfachlos profitierst du von einer kostenlosen Abholung.
          </li>
          <li>
            <strong>Rechtliche Absicherung: </strong>
            Dokumentiere im Kaufvertrag alle Schäden und Vereinbarungen, um dich
            rechtlich abzusichern.
          </li>
        </ol>

        <p>
          Mit diesen Tipps stellst du sicher, dass der Verkauf deines
          Unfallautos rechtlich sicher und stressfrei abläuft. Autoeinfachlos
          macht es dir einfach: Wertermittlung, Bestpreis und kostenlose
          Abholung – alles aus einer Hand!
        </p>
      </>
    ),
  },
  {
    question: "Muss ich den Unfallschaden beim Verkauf angeben?",
    answer: (
      <>
        <p>
          Ja, du bist gesetzlich verpflichtet, den Unfallschaden beim Verkauf
          deines Autos anzugeben. Der Schaden muss ehrlich offengelegt und im
          Kaufvertrag dokumentiert werden – unabhängig davon, ob es sich um
          einen reparierten oder unreparierten Schaden handelt.
        </p>
        <p>
          Das Verschweigen eines Unfalls kann als Täuschung oder sogar Betrug (§
          146 StGB) gewertet werden und rechtliche Konsequenzen nach sich
          ziehen. Käufer haben in solchen Fällen das Recht, den Kauf rückgängig
          zu machen oder Schadenersatz zu fordern.
        </p>
      </>
    ),
  },
  {
    question: "Unfallauto oder Totalschaden – wo ist der Unterschied?",
    answer: (
      <>
        <p>
          Ein Unfallauto ist ein Fahrzeug, das durch einen Unfall beschädigt
          wurde, aber noch repariert werden kann. Ein Totalschaden liegt vor,
          wenn die Reparaturkosten den aktuellen Marktwert des Autos
          übersteigen.
        </p>
      </>
    ),
  },
  {
    question:
      "Wie funktioniert der Verkauf eines Unfallautos mit Autoeinfachlos?",
    answer: (
      <>
        <p>
          Der Verkauf deines Unfallautos mit Autoeinfachlos ist schnell, einfach
          und transparent. So läuft der Prozess ab:
        </p>
        <ol className="AV-Fragen-ol">
          <li>
            <strong>Daten eingeben: </strong>
            Trage Fahrzeugdetails wie Fahrgestellnummer, Kilometerstand und
            Zustand online ein.
          </li>
          <li>
            <strong>Marktgerechte Bewertung erhalten: </strong>
            Unsere Software berechnet den Wert deines Unfallautos und liefert
            dir eine Orientierung.
          </li>
          <li>
            <strong>Händlerauktion: </strong>
            Über 5.000 geprüfte Händler bieten auf dein Fahrzeug, sodass du
            automatisch den besten Preis erzielst.
          </li>
          <li>
            <strong>Angebot annehmen: </strong>
            Wähle das beste Angebot und akzeptiere es.
          </li>
          <li>
            <strong>Kostenlose Abholung und Bezahlung: </strong>
            Dein Unfallauto wird kostenlos abgeholt, und der Betrag wird direkt
            auf dein Konto überwiesen.
          </li>
        </ol>

        <p>
          Möchtest du mehr über den Verkaufsprozess erfahren? Besuche unser
          Hilfezentrum unter{" "}
          <Link
            href="/faq/verkaufen-mit-autoeinfachlos"
            className="FragenAntworten-link"
          >
            Verkaufen mit Autoeinfachlos.
          </Link>
        </p>
      </>
    ),
  },
  {
    question: "Wie lange dauert es, mein Unfallauto zu verkaufen?",
    answer: (
      <>
        <p>
          Mit Autoeinfachlos kannst du dein Unfallauto schnell und unkompliziert
          verkaufen. In den meisten Fällen ist der gesamte Prozess – von der
          Bewertung bis zur Abholung – innerhalb von 24 bis 72 Stunden
          abgeschlossen. Dank unserer effizienten Online-Auktionen und unserem
          großen Netzwerk von über 5.000 Händlern erhältst du schnell ein
          Angebot und kannst dein Auto stressfrei verkaufen.
        </p>
      </>
    ),
  },
  {
    question: "Wer übernimmt die Abholung meines Unfallautos?",
    answer: (
      <>
        <p>
          Die Abholung deines Unfallautos wird von dem Händler übernommen, der
          dein Fahrzeug kauft. Die Abholung für dich ist komplett kostenlos und
          erfolgt an einem Ort deiner Wahl – egal, ob bei dir zu Hause, am
          Arbeitsplatz oder an einem anderen Standort. So musst du dich nicht um
          Transport oder Abschleppkosten kümmern, selbst wenn dein Auto nicht
          mehr fahrbereit ist.
        </p>
      </>
    ),
  },
  {
    question: "Wie wird der Wert meines Unfallautos ermittelt?",
    answer: (
      <>
        <p>
          Der Wert deines Unfallautos wird bei Autoeinfachlos marktgerecht und
          transparent ermittelt. Dabei kombinieren wir modernste Software mit
          der Expertise unserer Fachleute, um den besten Marktwert für dein
          Fahrzeug zu erzielen.
        </p>
        <ol className="AV-Fragen-ol">
          <li>
            <strong>Datenanalyse: </strong>
            Unsere Software analysiert die von dir angegebenen Daten wie
            Fahrzeugmodell, Kilometerstand und Zustand und liefert eine erste
            Orientierung des Wertes.
          </li>

          <li>
            <strong>Individuelle Prüfung: </strong>
            Unsere Experten berücksichtigen Unfallschäden, Restwert und weitere
            Faktoren, um eine realistische und marktgerechte Bewertung deines
            Autos zu erstellen.
          </li>

          <p>
            Diese beiden Schritte dienen dazu, dir eine fundierte Bewertung zu
            bieten. Es handelt sich hierbei nicht um einen Ankaufspreis, sondern
            um den tatsächlichen Marktwert deines Unfallautos.
          </p>

          <li>
            <strong>Händlerauktion: </strong>
            Über 5.000 geprüfte Händler bieten in einer Online-Auktion auf dein
            Fahrzeug. Der Wettbewerb zwischen den Händlern sorgt dafür, dass du
            den höchstmöglichen Verkaufspreis erhältst.
          </li>
        </ol>

        <p>
          Mit Autoeinfachlos kannst du sicher sein, dass der Wert deines
          Unfallautos fair, präzise und zuverlässig ermittelt wird – einfach,
          schnell und ohne Aufwand!
        </p>
      </>
    ),
  },
  {
    question:
      "Was sind die Vorteile, wenn ich mein Unfallauto über Autoeinfachlos verkaufe?",
    answer: (
      <>
        <p>
          Der Verkauf deines Unfallautos über Autoeinfachlos bietet dir
          zahlreiche Vorteile:
        </p>

        <ol className="AV-Fragen-ol">
          <li>
            <strong>Marktgerechte Bewertung: </strong>
            Unsere Software und Experten ermitteln den echten Marktwert deines
            Fahrzeugs – fair, transparent und realistisch.
          </li>
          <li>
            <strong>Höchster Verkaufspreis: </strong>
            In einer Online-Auktion bieten über 5.000 geprüfte Händler auf dein
            Auto. Dieser Wettbewerb garantiert dir den bestmöglichen Preis.
          </li>
          <li>
            <strong>Kostenlose Abholung: </strong>
            Egal, ob dein Auto fahrbereit ist oder nicht – wir holen dein
            Fahrzeug kostenlos bei dir zu Hause, am Arbeitsplatz oder einem Ort
            deiner Wahl ab.
          </li>
          <li>
            <strong>Schneller Verkaufsprozess: </strong>
            Innerhalb von 24 bis 72 Stunden ist dein Verkauf abgeschlossen –
            inklusive Bewertung, Auktion und Abholung.
          </li>
          <li>
            <strong>Stressfreie Abwicklung: </strong>
            Keine mühsame Suche nach Käufern, keine Verhandlungen und kein
            Aufwand. Alles wird bequem für dich erledigt.
          </li>
          <li>
            <strong>Schnelle Bezahlung: </strong>
            Nach Annahme des Angebots wird das Geld direkt und sicher auf dein
            Konto überwiesen.
          </li>

          <p>
            Mit Autoeinfachlos verkaufst du dein Unfallauto einfach, sicher und
            zu den besten Konditionen – ohne Stress oder versteckte Kosten!
          </p>
        </ol>
      </>
    ),
  },
];
